import { FaMinus } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa6";
import Button from "@mui/material/Button";
import { useContext, useEffect, useState, useCallback } from "react";
import { MyContext } from "../../App";

const QuantityBox = (props) => {
  const [inputVal, setInputVal] = useState(1);
  const context = useContext(MyContext);

  useEffect(() => {
    if (
      props?.value !== undefined &&
      props?.value !== null &&
      props?.value !== ""
    ) {
      setInputVal(parseInt(props?.value));
    }
  }, [props.value]);

  const minus = useCallback(() => {
    if (inputVal !== 1 && inputVal > 0) {
      setInputVal(inputVal - 1);
    }
    context.setAlertBox({
      open: false,
    });
  }, [inputVal, context]);

  const plus = useCallback(() => {
    let stock = parseInt(props.item.prices[props.index].countInStock);
    if (inputVal < stock) {
      setInputVal(inputVal + 1);
    } else {
      context.setAlertBox({
        open: true,
        error: true,
        msg: "The quantity is greater than product count in stock",
      });
    }
  }, [inputVal, props.item, props.index, context]);

  useEffect(() => {
    if (props.quantity) {
      props.quantity(inputVal);
    }

    if (props.selectedItem) {
      props.selectedItem(props.item, inputVal);
    }
  }, [inputVal, props]);

  return (
    <div className="quantityDrop d-flex align-items-center">
      <Button onClick={minus} disabled={props.isInCart}>
        <FaMinus />
      </Button>
      <input type="text" value={inputVal} readOnly />
      <Button onClick={plus} disabled={props.isInCart}>
        <FaPlus />
      </Button>
    </div>
  );
};

export default QuantityBox;
